import React, { useState, useEffect } from 'react';
import { Table, message, Spin, Card, Statistic, Row, Col } from 'antd';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../axiosInstance';
import { getPermission } from '../../constants';

const CustomerLedger = () => {
    const { customerId, shopId } = useParams();
    const [ledgerData, setLedgerData] = useState({ invoices: [], receipts: [], summary: {} });
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
        fetchLedger();
    }, [customerId, shopId]);
    const fetchLedger = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(`/customer-ledger/${customerId}/${shopId}`);
            setLedgerData(response.data);
        } catch (error) {
            message.error('Failed to fetch ledger.');
        } finally {
            setLoading(false);
        }
    };

    const commonColumns = [
        { title: 'Date', dataIndex: 'date', key: 'date' },
        { title: 'Total', dataIndex: 'total', key: 'total' },
        { title: 'Discount', dataIndex: 'discount', key: 'discount' },
        { title: 'Status', dataIndex: 'status', key: 'status' },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <a href={`/sales/${record.id}`} target="_blank" rel="noreferrer">
                    View Sale
                </a>
            ),
        },
    ];

    return (
        <div>
            <h2>Customer Ledger</h2>
            {loading ? (
                <Spin />
            ) : (
                <>
                    <Row gutter={16} style={{ marginBottom: 24 }}>
                        <Col span={6}><Card><Statistic title="Total Invoiced" value={ledgerData.summary.total_invoiced || 0} precision={2} /></Card></Col>
                        <Col span={6}><Card><Statistic title="Total Paid" value={ledgerData.summary.total_paid || 0} precision={2} /></Card></Col>
                        <Col span={6}><Card><Statistic title="Total Discount" value={ledgerData.summary.total_discount || 0} precision={2} /></Card></Col>
                        <Col span={6}><Card><Statistic title="Outstanding Balance" value={ledgerData.summary.outstanding_balance || 0} precision={2} /></Card></Col>
                    </Row>

                    <h3>Invoices</h3>
                    <Table
                        dataSource={ledgerData.invoices.map(i => ({ key: i.id, ...i }))}
                        columns={commonColumns}
                        pagination={false}
                        style={{ marginBottom: 32 }}
                    />

                    <h3>Receipts</h3>
                    <Table
                        dataSource={ledgerData.receipts.map(r => ({ key: r.id, ...r }))}
                        columns={commonColumns}
                        pagination={false}
                    />
                </>
            )}
        </div>
    );
};

export default CustomerLedger;
